import { table } from '@gitbook/doc-core';
import type { Block, Change } from '@gitbook/slate';

import type { TableState } from '../../types';

/**
 * Move the selection in this table subview.
 * It returns `false` if the move was not possible.
 */
export function relativeSelectionMove(
    change: Change,
    tableBlock: string | Block,
    tableState: TableState,
    move: {
        definition: { relative: number } | { absolute: number };
        record: { relative: number } | { absolute: number };
        focus?: 'end' | 'start' | 'select';
    }
): boolean {
    const { focus = 'end', definition: moveDefinition, record: moveRecord } = move;

    if (!tableState.selection.definitionId) {
        return false;
    }

    const rowIndex = tableState.records.findIndex(
        (entry) => entry.key === tableState.selection.recordId
    );
    const columnIndex = tableState.view.columns.indexOf(tableState.selection.definitionId);

    const newRecordEntry =
        tableState.records[
            'relative' in moveRecord ? rowIndex + moveRecord.relative : moveRecord.absolute
        ];
    const newDefinitionKey =
        tableState.view.columns[
            'relative' in moveDefinition
                ? columnIndex + moveDefinition.relative
                : moveDefinition.absolute
        ];
    if (!newDefinitionKey || !newRecordEntry) {
        return false;
    }

    table.moveTableSelection(
        change,
        tableBlock,
        {
            recordId: newRecordEntry.key,
            definitionId: newDefinitionKey,
        },
        focus
    );

    return true;
}

/**
 * Move the selection in this table subview at a record level.
 */
export function relativeRecordSelectionMove(
    change: Change,
    tableBlock: string | Block,
    tableState: TableState,
    move: { relative: number } | { absolute: number }
): boolean {
    const rowIndex = tableState.records.findIndex(
        (entry) => entry.key === tableState.selection.recordId
    );

    const newRecordEntry =
        tableState.records['relative' in move ? rowIndex + move.relative : move.absolute];

    if (!newRecordEntry) {
        return false;
    }

    table.moveTableSelection(change, tableBlock, {
        recordId: newRecordEntry.key,
        definitionId: undefined,
    });

    return true;
}
